import { Flex, Icon, Link, Text } from '@chakra-ui/react';
import { ArrowRightIcon } from '@heroicons/react/24/outline';

export default function Footer() {
  return (
    <Flex
      as='footer'
      w='full'
      borderTop='1px solid'
      borderColor='border'
      bg='bg.panel'
      justify='space-between'
      align='center'
      gap={4}
      flexWrap='wrap'
      py={3}
      px={{ base: 4, md: 6 }}
    >
      <Text
        as='span'
        fontFamily='heading'
        fontSize='label'
        fontWeight='semibold'
        textTransform='uppercase'
        letterSpacing='label'
        color='fg.muted'
      >
        Powered by{' '}
        <Text as='strong' color='fg.strong' fontWeight='bold'>
          Coach Hub
        </Text>
      </Text>

      <Flex align='center' gap={{ base: 4, md: 6 }} flexWrap='wrap'>
        <Link
          href='https://forms.gle/2ovV2UYc3SvL8ov48'
          target='_blank'
          rel='noopener'
          display='inline-flex'
          alignItems='center'
          fontFamily='heading'
          fontSize='label'
          fontWeight='bold'
          textTransform='uppercase'
          letterSpacing='label'
          textDecoration='none'
          px={5}
          py={2}
          borderRadius='full'
          border='1.5px solid'
          borderColor='border.emphasized'
          color='fg.strong'
          _hover={{ color: 'brand.solid', borderColor: 'brand.solid' }}
          transition='.15s'
        >
          Provide Feedback
        </Link>

        <Link
          href='https://athleteera.app'
          target='_blank'
          rel='noopener'
          display='inline-flex'
          alignItems='center'
          gap={2}
          fontFamily='heading'
          fontSize='label'
          fontWeight='bold'
          textTransform='uppercase'
          letterSpacing='label'
          textDecoration='none'
          px={5}
          py={2}
          borderRadius='full'
          border='1.5px solid'
          borderColor='border.emphasized'
          color='fg.strong'
          _hover={{ color: 'brand.solid', borderColor: 'brand.solid' }}
          transition='.15s'
        >
          Learn more
          <Icon as={ArrowRightIcon} boxSize='16px' />
        </Link>
      </Flex>
    </Flex>
  );
}
